import React from 'react';
import { inject } from 'mobx-react';

function withAuth(Component) {
	@inject(i => ({
		authStore: i.rootStore.authStore,
	}))
	class AuthComponent extends React.Component {
		render() {
			const { authStore, authorization, ...otherProps } = this.props;
			return authStore.hasPermission(authorization) ? <Component {...otherProps} /> : null;
		}
	}

	return AuthComponent;
}

export default withAuth;



// WEBPACK FOOTER //
// ./src/core/hoc/withAuth.js